import React, { useState, useEffect } from 'react'
import '../../../assets/scss/components/editor.scss'
import Controls from './Controls'
import TextBox from './TextBox'
import { useVoicesFilter } from '../../../hooks/useVoicesFilter'
import { useSelector, useDispatch } from 'react-redux'
import { getLoggedInUser } from '../../../redux/auth/authActions'

const Editor = () => {
    const loggedInUserVoices = useSelector((state) => state.auth.login.loggedInUser?.voices)
    const [
        vendors,
        selectedVendor,
        setSelectedVendor,
        languages,
        selectedLanguage,
        setSelectedLanguage,
        genders,
        selectedGender,
        setSelectedGender,
        voicesForLanguage
    ] = useVoicesFilter(loggedInUserVoices)

    const [pitch, setPitch] = useState(50);
    const [volume, setVolume] = useState(1);
    const [speedValue, setSpeedValue] = useState(1);
    const [text, setText] = useState('')
    const [selectedVoice, setSelectedVoice] = useState('')

    const [fileFormatValue, setFileFormatValue] = useState();

    return (
        <div className="editor justify-content-center ">

            <Controls
                volume={volume}
                setVolume={setVolume}
                speedValue={speedValue}
                setSpeedValue={setSpeedValue}
                selectedVoice={selectedVoice}
                setSelectedVoice={setSelectedVoice}
                vendors={vendors}
                selectedVendor={selectedVendor}
                setSelectedVendor={setSelectedVendor}
                languages={languages}
                selectedLanguage={selectedLanguage}
                setSelectedLanguage={setSelectedLanguage}
                genders={genders}
                selectedGender={selectedGender}
                setSelectedGender={setSelectedGender}
                voicesForLanguage={voicesForLanguage}
                fileFormatValue={fileFormatValue}
                setFileFormatValue={setFileFormatValue}
            />

            <TextBox
                text={text}
                setText={setText}
                selectedVoice={selectedVoice}
                selectedLanguage={selectedLanguage?.value}
                volume={volume}
                speedValue={speedValue}
                fileFormatValue={fileFormatValue}
            />

        </div>
    )
}

export default Editor